import { TOO_MANY_REQUESTS, RESET_API_ERRORS } from 'actions/apiErrorActions';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import cdnConstants from 'constants/cdn';

export default function apiError(state = {}, action = null) {
	switch (action.type) {
		case TOO_MANY_REQUESTS:
			return Object.assign({}, state, {
				title: stringTemplate('error429Title'),
				subtitle: action.data.errorMessage,
				image: `//${cdnConstants.domain}/www/promos/new/20160926-174505-kid-1.png`,
				titleClass: 'surge-error-title',
				imageClass: 'surge-image'
			});
		case RESET_API_ERRORS:
			return {};
		default:
			return state;
	}
}
